import React from 'react';

import { useI18n } from 'lib/i18n/context';

import ContractVerificationMethod from '../ContractVerificationMethod';
import ContractVerificationFieldContractIndex from '../fields/ContractVerificationFieldContractIndex';
import ContractVerificationFieldSources from '../fields/ContractVerificationFieldSources';
import { CONTRACT_VERIFICATION_FIELD_KEYS, CONTRACT_VERIFICATION_METHOD_TITLE_KEYS } from '../i18n';

const FILE_TYPES = [ '.json' as const, '.sol' as const ];

const ContractVerificationSourcify = () => {
  const { t } = useI18n();
  return (
    <ContractVerificationMethod title={ t(CONTRACT_VERIFICATION_METHOD_TITLE_KEYS.sourcify) }>
      <ContractVerificationFieldSources
        fileTypes={ FILE_TYPES }
        multiple
        required
        title={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.sourcifyTitle) }
        hint={ t(CONTRACT_VERIFICATION_FIELD_KEYS.sources.sourcifyHint) }
      />
      <ContractVerificationFieldContractIndex/>
    </ContractVerificationMethod>
  );
};

export default React.memo(ContractVerificationSourcify);
